__turbopack_context__.v({
  "redText": "FormatHeroText-module-scss-module__BBEnaW__redText",
});
